import { useSubscriptionCtx } from 'src/context/billing.context'
import moduleValid from 'src/lib/subscription/module-valid'

/**
 * @param {keyof import('zod').infer<typeof import('src/lib/zod-schemas/organization-subscription.schema').Subscription__schema>} module_name The module to check for
 */
export default function useModuleValid(module_name) {
    const ctx = useSubscriptionCtx()

    return moduleValid(ctx, module_name)
}
